module.exports = __webpack_public_path__ + "img/弈剑男.fed00c72.png";